import { useQuery } from '@tanstack/react-query'

import { termInstance } from '@/modules/terms'
import Terms from '@/ui/pages/Terms'

import { useAuthContext } from './AuthContext'

export default function TermProvider({
  children
}: {
  children: React.ReactNode
}) {
  const { userSession, personaSession } = useAuthContext()
  const userId = userSession?.userId

  const termsQuery = useQuery({
    queryKey: ['terms', userId],
    queryFn: async () =>
      await termInstance.getUserTermList(userId!.toString(), 'pt-BR'),
    initialData: [],
    enabled: !!userId && !!personaSession?.personaId,
    refetchInterval: 1000 * 60 * 60 * 24,
    refetchIntervalInBackground: true
  })

  return (
    <>
      {termsQuery.data.length > 0 && <Terms data={termsQuery.data} />}
      {children}
    </>
  )
}
